import ScanResults from './ScanResults';

export default ScanResults;
